import { useEffect } from 'react';
import { loadModules } from 'esri-loader';

const SearchWidget = ({ view }) => {
  useEffect(() => {
    if (!view) return;

    let search;

    loadModules(['esri/widgets/Search'],       
    ).then(([Search]) => {
      search = new Search({
        view,
        includeDefaultSources: true,
        popupEnabled: true,
        maxSuggestions: 6,
        maxResults: 3
      });

      view.ui.add(search, {
        position: 'top-right',
        index: 0
      });
    });

    return () => {
      if (search && view?.ui) {
        view.ui.remove(search);
        search.destroy();
      }
    };
  }, [view]);

  return null;
};

export default SearchWidget;
